import { clockLine } from '../lib/team-clock';
import type { TeamClockMember } from '../lib/types';

/**
 * One on-site team member's clock status, on the right of their row.
 *
 * The TEXT is the status; the dot repeats it in colour and is hidden from
 * assistive tech. Deliberately NOT `aria-live`: the panel refreshes every
 * minute and several rows can change on one refresh, so a live region would
 * announce the whole team over whatever the person is doing. The status reads
 * as part of the row's button, which is where someone looking for it is.
 *
 * Rendered only for a slot the API answered — never a placeholder, never a
 * "not clocked in" for someone PunchWISE does not see in use.
 */
export function ClockStatus({ member, facilityFiId }: { member: TeamClockMember; facilityFiId: number | null }) {
  const line = clockLine(member, facilityFiId);
  return (
    <span className={`clk ${line.tone}`}>
      <span className="clk-dot" aria-hidden="true"></span>
      <span className="clk-t">{line.text}</span>
    </span>
  );
}
